(ns dashboard.views.browser-extension.questionnaire.events
  (:require
   [re-frame.core :as rf]
   [dashboard.notifications :as notifications]
   [dashboard.services.http-config :as http-config]))

(rf/reg-event-db
 ::toggle-reorder
 (fn [db [_]]
   (let [enabled? (get-in db [:question-drag-enabled] false)]
     (assoc-in db [:question-drag-enabled] (not enabled?)))))

(rf/reg-event-fx
 ::move-question
 (fn [{:keys [db]} [_ questionnaire-id action-question-id place]]
   (let [questions (->> (get-in db [:questionnaires questionnaire-id :questions :data]))
         questions-by-id (group-by :id questions)
         action-question (-> (get questions-by-id action-question-id) first)

         grandparent-id (->> (:parent-id action-question)
                             (get questions-by-id)
                             first
                             :parent-id)
         index (condp = place
                 :before (dec (:ordinal action-question))
                 :after (:ordinal action-question)
                 :follow-up (dec (:ordinal action-question))
                 :move-to-parent (:ordinal action-question))
         comparator (if (= place :after) < >=)
         ;; Inheriting this project there are no schema rules to enforce or make sense of
         ;; the ordinals or how they are assigned. As a result, some ordinal values may
         ;; collide, in which case we use the completely arbitrary UUID to sort questions :(
         prior-questions (when-not (= place :move-to-parent)
                          (->> questions
                              (filter (comp (partial = (:section-id action-question))
                                            :section-id))
                              (sort-by (juxt :ordinal :id))
                              (filterv (fn [{:keys [ordinal id]}]
                                        (or (comparator index ordinal)
                                            (and (not= (:id action-question) id)
                                                 (= index ordinal)
                                                 ;; UUIDs - see above
                                                 (> (:id action-question) id)))))))
         target-question (cond (= place :after)
                               (first prior-questions)

                               (= place :move-to-parent)
                               (get-in questions-by-id [grandparent-id 0])

                               :else
                               (last prior-questions))]
     ; This feels a little odd
     (if-not (and (or (:ordinal target-question)
                      (= place :move-to-parent))
                  (:ordinal action-question))
       {:db db}
       {:db (dissoc db :question-drag-state)
        :fx [;; Set the Action Question
             (let [fields {:parent-id (cond
                                        (= place :follow-up)
                                        (:id target-question)

                                        (= place :move-to-parent)
                                        grandparent-id

                                        :else
                                        (:parent-id action-question))
                           :ordinal (if (#{:follow-up :move-to-parent} place)
                                      (:ordinal action-question)
                                      (:ordinal target-question))}
                   original (select-keys action-question (keys fields))]
               [:dispatch [::update-question questionnaire-id action-question-id fields original true]])
             ;; Set the target question
             (when-not (= place :move-to-parent)
              (let [fields {:parent-id (:parent-id target-question)
                           :ordinal (if (= place :follow-up)
                                      (:ordinal target-question)
                                      (:ordinal action-question))}
                   original (select-keys target-question (keys fields))]
               [:dispatch [::update-question questionnaire-id (:id target-question) fields original false]]))]}))))

(defn perform-update-question [db questionnaire-id question-id fields]
  (update-in db [:questionnaires questionnaire-id :questions :data]
             (fn [questions]
               (mapv (fn [{:keys [id] :as question}]
                       (if (= question-id id)
                         (merge question fields)
                         question))
                     questions))))

(rf/reg-event-fx
 ::update-question
 (fn [{:keys [db]} [_ questionnaire-id question-id fields original notify?]]
   {:db (-> (perform-update-question db questionnaire-id question-id fields)
            (assoc-in [:browsers-extension :question-list :question-restore-state question-id] original))
    :http-xhrio {:method :post
                 :uri (str "/api/questions/question/" question-id)
                 :params {:original original :changes fields}
                 :timeout http-config/timeout
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::update-question-success question-id notify?]
                 :on-failure [::update-question-failure questionnaire-id question-id notify?]}}))

(rf/reg-event-fx
 ::update-question-success
 (fn [{:keys [db]} [_ question-id notify?]]
   (cond-> {:db (update-in db [:browsers-extension :question-list :question-restore-state] dissoc question-id)}
     notify? (assoc :dispatch [::notifications/add {:message "Question moved successfully"
                                                    :class "is-success"}]))))

(rf/reg-event-fx
 ::update-question-failure
 (fn [{:keys [db]} [_ questionnaire-id question-id notify?]]
   (if-let [original-fields (get-in db [:browsers-extension :question-list :question-restore-state question-id])]
     ;; Restore original question fields to undo the changes
     (cond-> {:db (-> (perform-update-question db questionnaire-id question-id original-fields)
                      (update-in [:browsers-extension :question-list :question-restore-state] dissoc question-id))}
       notify? (assoc :dispatch [::notifications/add {:message "Failed to move question"
                                                      :class "is-danger"}]))
     {:db db})))

;; Section reordering

(rf/reg-event-db
 ::toggle-reorder-section
 (fn [db [_]]
   (let [enabled? (get-in db [:section-reorder-enabled] false)]
     (assoc-in db [:section-reorder-enabled] (not enabled?)))))
